import Vue from 'vue';
import VueI18n from 'vue-i18n';
import moment from 'moment';
import momentBusiness from 'moment-business-days';

import en from '@/assets/i18n/en.json';

Vue.use(VueI18n);

const translations = {
  en,
};

function getBrowserLang() {
  return navigator.language.slice(0, 2);
}

function getDefaultLang() {
  const browserLang = getBrowserLang();
  return browserLang && translations[browserLang] ? browserLang : 'en';
}

export const DEFAULT_LANGUAGE = getDefaultLang();

const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: translations,
});

moment.locale(DEFAULT_LANGUAGE);
momentBusiness.updateLocale(DEFAULT_LANGUAGE, {
  workingWeekdays: [0, 1, 2, 3, 4, 5], // Sunday is a working day
});

export function setLang(lang) {
  const language = localStorage.getItem('lang') || lang;
  i18n.locale = i18n.messages[language] !== undefined ? language : DEFAULT_LANGUAGE;
  moment.locale(i18n.locale);
}

export default i18n;

window.addEventListener('languagechange', () => setLang(getBrowserLang()));
